import { useEffect, useState } from 'react';

import { toast } from 'sonner';
import Honeybadger from '@honeybadger-io/js';

import { ERROR_TITLES, SUCCESS_MESSAGES } from '../constants';
import {
  fetchThemeEditorData as apiFetchThemeEditorData,
  updateThemeSettings as apiUpdateThemeSettings,
} from '../services/themeService';

const useStylesForm = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sectionSchemas, setSectionSchemas] = useState([]);
  const [themeSettings, setThemeSettings] = useState({});

  useEffect(() => {
    const fetchThemeEditorData = async () => {
      setIsLoading(true);

      try {
        const themeEditorData = await apiFetchThemeEditorData();

        setSectionSchemas(themeEditorData.section_schemas);
        setThemeSettings(themeEditorData.theme_settings);
      } catch (error) {
        toast.error(ERROR_TITLES.styles.fetch, { description: error.message });
        Honeybadger.notify(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchThemeEditorData();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      setErrorMessage('');
      setIsSubmitting(true);

      await apiUpdateThemeSettings(themeSettings);

      toast.success(SUCCESS_MESSAGES.styles.update);
    } catch (error) {
      setErrorMessage(error.message);
      Honeybadger.notify(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    errorMessage,
    handleSubmit,
    isLoading,
    isSubmitting,
    sectionSchemas,
    setThemeSettings,
    themeSettings,
  };
};

export default useStylesForm;
